import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add-white",
  "use": "icon-add-white-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add-white\">\n  <rect x=\"2\" y=\"6\" width=\"10\" height=\"2\" fill=\"white\" />\n  <rect x=\"6\" y=\"2\" width=\"2\" height=\"10\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol